/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getConsumables } from 'app/entities/consumable/consumable.reducer';
import { getEntities as getImplants } from 'app/entities/implant/implant.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-limit.reducer';

export const PharmacyLimitUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const medicines = useAppSelector(state => state.medicine.entities);
  const consumables = useAppSelector(state => state.consumable.entities);
  const implants = useAppSelector(state => state.implant.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyLimitEntity = useAppSelector(state => state.pharmacyLimit.entity);
  const loading = useAppSelector(state => state.pharmacyLimit.loading);
  const updating = useAppSelector(state => state.pharmacyLimit.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyLimit.updateSuccess);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-limit${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMedicines({}));
    dispatch(getConsumables({}));
    dispatch(getImplants({}));
    dispatch(getPharmacies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lowerLimit !== undefined && typeof values.lowerLimit !== 'number') {
      values.lowerLimit = Number(values.lowerLimit);
    }
    if (values.fmDays !== undefined && typeof values.fmDays !== 'number') {
      values.fmDays = Number(values.fmDays);
    }
    if (values.fmPercent !== undefined && typeof values.fmPercent !== 'number') {
      values.fmPercent = Number(values.fmPercent);
    }
    if (values.smDays !== undefined && typeof values.smDays !== 'number') {
      values.smDays = Number(values.smDays);
    }
    if (values.smPercent !== undefined && typeof values.smPercent !== 'number') {
      values.smPercent = Number(values.smPercent);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyLimitEntity,
      ...values,
      drug: medicines.find(it => it.id.toString() === values.drug?.toString()),
      consumable: consumables.find(it => it.id.toString() === values.consumable?.toString()),
      implant: implants.find(it => it.id.toString() === values.implant?.toString()),
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyLimitEntity,
          drug: pharmacyLimitEntity?.drug?.id,
          consumable: pharmacyLimitEntity?.consumable?.id,
          implant: pharmacyLimitEntity?.implant?.id,
          pharmacy: pharmacyLimitEntity?.pharmacy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyLimit.home.createOrEditLabel" data-cy="PharmacyLimitCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyLimit.home.createOrEditLabel">Create or edit a PharmacyLimit</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-limit-id"
                  label={translate('tinyMedicRestApp.pharmacyLimit.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.lowerLimit')}
                id="pharmacy-limit-lowerLimit"
                name="lowerLimit"
                data-cy="lowerLimit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.fmDays')}
                id="pharmacy-limit-fmDays"
                name="fmDays"
                data-cy="fmDays"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.fmPercent')}
                id="pharmacy-limit-fmPercent"
                name="fmPercent"
                data-cy="fmPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.smDays')}
                id="pharmacy-limit-smDays"
                name="smDays"
                data-cy="smDays"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.smPercent')}
                id="pharmacy-limit-smPercent"
                name="smPercent"
                data-cy="smPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.active')}
                id="pharmacy-limit-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.cursor')}
                id="pharmacy-limit-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.lastUpdated')}
                id="pharmacy-limit-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.microSec')}
                id="pharmacy-limit-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.timestampEntry')}
                id="pharmacy-limit-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.addedById')}
                id="pharmacy-limit-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.modifiedById')}
                id="pharmacy-limit-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.addedByType')}
                id="pharmacy-limit-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyLimit.modifiedByType')}
                id="pharmacy-limit-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-limit-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.pharmacyLimit.drug')}
                type="select"
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-limit-consumable"
                name="consumable"
                data-cy="consumable"
                label={translate('tinyMedicRestApp.pharmacyLimit.consumable')}
                type="select"
              >
                <option value="" key="0" />
                {consumables
                  ? consumables.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-limit-implant"
                name="implant"
                data-cy="implant"
                label={translate('tinyMedicRestApp.pharmacyLimit.implant')}
                type="select"
              >
                <option value="" key="0" />
                {implants
                  ? implants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-limit-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyLimit.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-limit" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyLimitUpdate;
